import networkAdapter from '../adapters/network';
import { get } from 'lodash';
import { DATA_LEGITIMACY } from '../constants/values';

export const fetchDeviceList = ( {userId} ) => {
  const legacyOptions = {
    // this mycroft endpoint handles data legitimacy via a query param instead of a header
    // artificial is lowercase because mycroft is case sensitive on that query parameter
    url: '/api/mycroft/v2/prescriptions/download/devices?dataLegitimacy=artificial',
    dataLegitimacy: DATA_LEGITIMACY.artificial,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchPreferredDevice = ( {userId, operationUuid} ) => {
  const legacyOptions = {
    url: `/api/groot/v2/devices/${operationUuid}?device-category=seeding`,
    userId,
    redirectsToLoginOnAuthFail: false,
    defaultResponse: null
  };
  
  return networkAdapter({
    legacyOptions
  });
};

const DEVICE_DRIVE_COUNT = 50;

export const fetchDriveDevices = (userId, acc = [], after = null) => {
  const olRequestOptions = {
    userId,
    olVersion: '2',
    headers: {
      'x-data-origin': 'dfpMocks'
    },
    query: `
    fragment Nodes on Device {
        id
        name
        description
        deviceModelId
      }
      query {
        devices(deviceType: DRIVE_2, first: ${DEVICE_DRIVE_COUNT}, after: ${after}) {
          nodes {
            ...Nodes
          }
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          edges {
            node {
              ...Nodes
            }
            confidenceScore
          }
        }
      }
    `
  };
  return networkAdapter({
    options: olRequestOptions,
    useOL: true
  }).then(result => {
    const hasNextPage = get(result, 'data.devices.pageInfo.hasNextPage');
    const endCursor = get(result, 'data.devices.pageInfo.endCursor');
    const driveDevices = get(result, 'data.devices.nodes');
    const newDriveDevices = acc.concat(driveDevices);
    if (hasNextPage) {
      return fetchDriveDevices(userId, newDriveDevices, endCursor);
    }
    return newDriveDevices;
  });
};
